export default "__VITE_ASSET__XLtBHv4S__"